import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'react-popup';

import ExamplePanel from '../Shared/Helpers/ExamplePanel';
import Footer from '../Shared/Helpers/Footer';
import PageTitle from '../Shared/Helpers/PageTitle';
// import Sidebar from '../Shared/Helpers/Sidebar';
import Toolbar from '../Shared/Helpers/Toolbar';

const Backend = props => (
  <div className="page-inner">
    <Toolbar />
    {/* <Sidebar /> */}

    <div className="main">
      <PageTitle />

      <div className="content">
        <Popup />
        {props.children}
      </div>

      <Footer />
    </div>

    <div className="content-side-wrapper">
      <div className="content-side-overlay" />

      <div className="content-side">
        <ExamplePanel />
      </div>
    </div>
  </div>
);

Backend.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Backend;



// WEBPACK FOOTER //
// ./src/Layouts/Backend.js